<template>
    <div class="content">
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('sleepNeed.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="today-total">
            <div class="today-total-value"><span class="today-total-value-num">7</span>h<span class="today-total-value-num">45</span>m</div>
            <div class="today-total-key"> {{$t('sleepNeed.todayNeed')}}</div>
        </div>
        <div class="recommend-box">
            <div class="recommend-item">
                <img class="recommend-img" src="@/assets/theme/light/status/06sleep/03start.svg">
                <div class="recommend-time">23:32</div>
                <div class="recommend">{{$t('sleepNeed.recommend')}}</div>
                <div class="recommend">{{$t('sleepNeed.bedtime')}}</div>
            </div>
            <div class="recommend-item">
                <img class="recommend-img" src="@/assets/theme/light/status/06sleep/04end.svg">
                <div class="recommend-time">07:32</div>
                <div class="recommend">{{$t('sleepNeed.recommend')}}</div>
                <div class="recommend">{{$t('sleepNeed.wakeup')}}</div>
            </div>
        </div>
        <div class="sleep-line">
            <div class="sleep-health"></div>
            <div class="sleep-recent"></div>
            <div class="sleep-debt"></div>
        </div>
        <div class="sleep-item">
            <div class="sleep-item-left">
                <div class="sleep-health-bar"></div>
                <div class="sleep-item-title">{{$t('sleepNeed.healthMin')}}</div>
            </div>

            <div class="sleep-item-time">7h1m</div>
        </div>
        <div class="sleep-item">
            <div class="sleep-item-left">
                <div class="sleep-recent-bar"></div>
                <div class="sleep-item-title">{{$t('sleepNeed.recentStrain')}}</div>
            </div>

            <div class="sleep-item-time">7h1m</div>
        </div>
        <div class="sleep-item">
            <div class="sleep-item-left">
                <div class="sleep-debt-bar"></div>
                <div class="sleep-item-title">{{$t('sleepNeed.sleepDebt')}}</div>
            </div>

            <div class="sleep-item-time">7h1m</div>
        </div>
    </div>
</template>

<script>
import {getQueryVariable} from "../../utils/comment";

export default {
    name: '29sleepNeed',
    data() {
        return {
            theme: getQueryVariable("theme") ? getQueryVariable("theme") : "light",
        }
    },
    mounted() {
    },
    methods: {
    }
}
</script>

<style scoped>
.today-total-value {
    font-weight: bold;
    font-size: 20px;
    color: var(--chart-color-8);
    text-align: center;
    letter-spacing: 2px;
}

.today-total-value-num {
    font-size: 30px;
    margin: 0 4px;
}

.today-total-key {
    font-size: 11px;
    color: var(--text-color-2);
    text-align: center;
}

.recommend-box {
    display: flex;
    justify-content: space-between;
    width: 343px;
    margin:  12px auto;
}

.recommend-item {
    width: 165px;
    height: 84px;
    background: var(--bg-color-2);
    border-radius: 8px 8px 8px 8px;
    text-align: center;
}

.recommend-time {
    font-size: 20px;
    color: var(--text-color-1);
    line-height: 20px;
}

.recommend {
    color: var(--text-color-2);
    font-size: 11px;
}

.recommend-img {
    width: 14px;
    display: block;
    margin: 0 auto;
    padding: 8px 0 2px;
}

.sleep-line {
    width: 343px;
    margin: 16px auto;
    height: 12px;
    border-radius: 4px;
    display: flex;
}

.sleep-health {
    border-radius: 4px 0 0 4px;
    width: 283px;
    height: 12px;
    background: var(--chart-color-8);
    /* 把 45deg 改成 -45deg，斜纹方向就反过来了 */
    background-image:
        repeating-linear-gradient(
            -45deg,
            var(--bg-color-1) 0px,
            var(--bg-color-1) 4px,
            transparent 4px,
            transparent 8px
        );
}

.sleep-recent {
    width: 34px;
    height: 12px;
    background: var(--chart-color-13);
    margin: 0 2px;
}

.sleep-debt {
    width: 22px;
    height: 12px;
    background: var(--chart-color-17);
    border-radius: 0px 4px 4px 0px;
}

.sleep-item {
    width: 343px;
    margin: 15px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.sleep-item-left {
    display: flex;
    align-items: center;
}

.sleep-health-bar {
    width: 12px;
    height: 12px;
    background: var(--chart-color-8);
    /* 把 45deg 改成 -45deg，斜纹方向就反过来了 */
    background-image:
        repeating-linear-gradient(
            -45deg,
            var(--bg-color-1) 0px,
            var(--bg-color-1) 3px,
            transparent 3px,
            transparent 6px
        );
    border-radius: 2px 2px 2px 2px;
}

.sleep-item-title {
    font-size: 13px;
    color: var(--text-color-2);
    letter-spacing: 2px;
    margin-left: 6px;
}

.sleep-item-time {
    font-size: 13px;
}

.sleep-recent-bar {
    width: 12px;
    height: 12px;
    background: var(--chart-color-13);
    border-radius: 2px 2px 2px 2px;
}

.sleep-debt-bar {
    width: 12px;
    height: 12px;
    background: var(--chart-color-17);
    border-radius: 2px 2px 2px 2px;
}
</style>


// WEBPACK FOOTER //
// src/views/status/29sleepNeed.vue